module.exports = __webpack_public_path__ + "static/media/salisbury-12.18366c27.jpg";